module.exports = __webpack_public_path__ + "static/img/Saturn.ea6e697.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Saturn.svg
// module id = 1416
// module chunks = 0